import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = { entities: {}, loading: 'idle' };

const serverURL = process.env.REACT_APP_SERVER;

export const fetchSearchResults = createAsyncThunk(
  'user/fetchSearchResults',
  async (username) => {
    try {
      const response = await axios({
        method: 'POST',
        url: `${serverURL}/profiles/findFriend`,
        headers: { 'x-auth-token': localStorage.getItem('x-auth-token') },
        data: { username: username },
      });
      return response.data;
    } catch (err) {
      console.log(err);
    }
  }
);

export const fetchUser = createAsyncThunk('user/fetchUser', async (userId) => {
  try {
    const response = await axios({
      method: 'GET',
      url: `${serverURL}/profiles/user`,
      headers: { 'x-auth-token': localStorage.getItem('x-auth-token') },
      data: userId,
    });
    return { err: false, msg: response.data.msg };
  } catch (err) {
    console.log(err);
  }
});

export const fetchCurrentUser = createAsyncThunk('user/fetchUser', async () => {
  try {
    const response = await axios({
      method: 'GET',
      url: `${serverURL}/profiles/currentUser`,
      headers: { 'x-auth-token': localStorage.getItem('x-auth-token') },
    });
    return response.data.profile;
  } catch (err) {
    console.log(err);
  }
});

export const loginUser = createAsyncThunk('user/loginUser', async (user) => {
  try {
    const response = await axios({
      method: 'POST',
      url: `${serverURL}/authenticate/login`,
      data: user,
    });
    if (response.data.msg === 'User successfully logged in') {
      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('x-auth-token', response.data.token);
    }
    return { err: false, msg: response.data.msg };
  } catch (err) {
    console.log(err);
    return { err: true, msg: err.response.data.msg };
  }
});

export const registerUser = createAsyncThunk(
  'user/registerUser',
  async (user) => {
    try {
      const response = await axios({
        method: 'POST',
        url: `${serverURL}/authenticate/register`,
        data: user,
      });
      if (response.data.msg === 'User successfully created and logged in') {
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('x-auth-token', response.data.token);
      }
      return { err: false, msg: response.data.msg };
    } catch (err) {
      console.log(err);
      return { err: true, msg: err.response.data.msg };
    }
  }
);

export const updateUser = createAsyncThunk('user/updateUser', async (user) => {
  try {
    const response = await axios({
      method: 'PATCH',
      url: `${serverURL}/profiles/updateUserInfo`,
      headers: { 'x-auth-token': localStorage.getItem('x-auth-token') },
      data: user,
    });
    return { err: false, msg: response.data.msg };
  } catch (err) {
    console.log(err.response.data);
    return { err: true, msg: err.response.data.msg };
  }
});

//creates a slice called "user" set to the initial state defined above
const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    logoutUser() {
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('x-auth-token');
    },
  },
  extraReducers: {
    [fetchCurrentUser.fulfilled]: (state, action) => {
      state.entities.currentUser = action.payload;
    },
  },
});

export const { logoutUser } = userSlice.actions;

export default userSlice.reducer;

export const selectCurrentUser = (state) => state.user.entities.currentUser;
